import React from "react";
import { Play } from "lucide-react";
import {
  formatJobTimeLeft,
  jobLedgerSubline,
  jobMsUntilNext,
  queueAccent,
} from "./systemHelpers";

export default function SystemJobCard({ job, now, redisOk, triggering, onRun }) {
  const msLeft = jobMsUntilNext(job, now);
  const accent = queueAccent(job.queue);
  const hot = msLeft != null && msLeft <= 120000;
  const canRun = redisOk && !triggering;
  const whenLabel = job.cron ? formatJobTimeLeft(msLeft) : "Manual";

  return (
    <article className={`asys-job-row${hot ? " asys-job-row-hot" : ""}`}>
      <span
        className="asys-job-when"
        style={{ borderColor: `${accent}44`, color: accent }}
        title={job.nextRunAt || undefined}
      >
        {whenLabel}
      </span>

      <div className="asys-job-body">
        <div className="asys-job-top">
          <h3 className="asys-job-name">{job.name}</h3>
          <span
            className="asys-job-queue"
            style={{ color: accent, borderColor: `${accent}33` }}
          >
            {job.queue}
          </span>
        </div>
        <p className="asys-job-sub">{jobLedgerSubline(job, now)}</p>
        {job.scheduleNote ? <p className="asys-job-note">{job.scheduleNote}</p> : null}
        <div className="asys-job-foot">
          <button
            type="button"
            className="asys-run-btn"
            disabled={!canRun}
            onClick={() => onRun(job.name)}
          >
            <Play size={10} aria-hidden />
            {triggering ? "Queueing…" : "Run now"}
          </button>
        </div>
      </div>
    </article>
  );
}
